import NavBar from '../components/Navbar/NavBar';
import HeroSection from './HeroSection';

const Hero = () => {
    return (
        <>
            <div className="hero" id='hero'>
                <div>
                    <NavBar />
                </div>
                <div>
                    <HeroSection />
                </div>
            </div>
        </>
    )
}

export default Hero;

